import { render, staticRenderFns } from "./CheckBox3.vue?vue&type=template&id=0614b121&scoped=true"
import script from "./CheckBox3.vue?vue&type=script&lang=js"
export * from "./CheckBox3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614b121",
  null
  
)

export default component.exports